import { useState } from "react";

import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { Button, Modal } from "@covertree/ui";

interface CommunityConfigurationActionsProps {
  isSaving: boolean;
  onActivate: () => Promise<void>;
  onSaveDraft: () => Promise<void>;
  onValidateActivation: () => Promise<boolean>;
  portfolioName: string;
}

export function CommunityConfigurationActions({
  isSaving,
  onActivate,
  onSaveDraft,
  onValidateActivation,
  portfolioName,
}: CommunityConfigurationActionsProps) {
  const [confirmActivation, setConfirmActivation] = useState(false);

  return (
    <>
      <Paper
        elevation={4}
        sx={{
          bottom: 0,
          left: 0,
          position: "sticky",
          px: 3,
          py: 2,
          zIndex: 2,
        }}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="flex-end"
          spacing={2}>
          <Button
            disabled={isSaving}
            type="button"
            variant="outlined"
            onClick={() => void onSaveDraft()}>
            {isSaving ? "Saving…" : "Save draft"}
          </Button>
          <Button
            disabled={isSaving}
            type="button"
            variant="contained"
            onClick={async () => {
              if (await onValidateActivation()) setConfirmActivation(true);
            }}>
            Validate and activate
          </Button>
        </Stack>
      </Paper>

      <Modal
        maxWidth="sm"
        open={confirmActivation}
        title={`Activate ${portfolioName}?`}
        onClose={() => setConfirmActivation(false)}>
        <Stack spacing={3}>
          <Typography>
            Activation makes the selected communities available to operational
            workflows. Draft configuration can no longer be edited from this
            screen.
          </Typography>
          <Stack direction="row" justifyContent="flex-end" spacing={1}>
            <Button type="button" onClick={() => setConfirmActivation(false)}>
              Cancel
            </Button>
            <Button
              variant="contained"
              disabled={isSaving}
              type="button"
              onClick={async () => {
                setConfirmActivation(false);
                await onActivate();
              }}>
              Activate portfolio
            </Button>
          </Stack>
        </Stack>
      </Modal>
    </>
  );
}
